import React from "react";
import { VMBuilder } from "../../../commons/base/providers/builder";
import MenuPreparationBomDashboardViewModel from "../view_models/menu_preparation_bom_view_model";

export default class MenuPreparationBomDashboardSearchWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<MenuPreparationBomDashboardViewModel>>
                {(vm) => (
                    <div className="relative flex-grow w-full">
                        <input
                            type="text"
                            placeholder="Cari Nama Menu"
                            className="h-9 px-2 block appearance-none w-full bg-white border border-gray-300 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline"
                            onChange={(e) =>
                                vm.updateSearchKeyword(e.target.value)
                            }
                            value={vm.searchKeyword}
                        />
                    </div>
                )}
            </VMBuilder>
        );
    }
}
